export default function HelpchatModel(dict) {
    this.agencyId = dict.AgencyId;
    this.agencyName = dict.AgencyName;
    this.appId = dict.AppId;
    this.buzzKey = dict.BuzzKey;
    this.campaignId = dict.CampaignId;
    this.commentCount = dict.CommentCount;
    this.createdTime = dict.CreatedTime;
    this.eTag = dict.ETag;
    this.height = dict.Height;
    this.imageUrl = dict.ImageUrl;
    this.isApproved = dict.IsApproved;
    this.isLiked = dict.IsLiked;
    this.isRead = dict.IsRead;
    this.isReply = dict.IsReply;
    this.likes = dict.Likes;
    this.locationAgencyId = dict.LocationAgencyId;
    this.message = dict.Message;
    this.name = dict.Name;
    this.os = dict.Os;
    this.partitionKey = dict.PartitionKey;
    this.photoId = dict.PhotoId;
    this.placeId = dict.PlaceId;
    this.placeName = dict.PlaceName;
    this.postId = dict.PostId;
    this.rating = dict.Rating;
    this.rowKey = dict.RowKey;
    this.sticker = dict.Sticker;
    this.timestamp = dict.Timestamp;
    this.type = dict.Type;
    this.userId = dict.UserId;
    this.width = dict.Width;
}
